import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

export const MODAL_CONFIG: NgbModalOptions = {
  centered: true,
  backdrop: 'static',
};
